import register  from '../register.js';
import dom       from '../lib/util/dom.js';
import phoneMask from '../lib/util/phone-mask';

register( 'bring-me-starry-form', function() {
  let form        = document.querySelector('.decision-maker-info');
  let name        = form.querySelector('input[name="name"]');
  let email       = form.querySelector('input[name="email"]');
  let phone       = form.querySelector('input[name="phone"]');
  let submitBtn   = form.querySelector('button[type="submit"]');
  let waitlist_id = form.querySelector('input[name="waitlist_id"]');
  let formError   = form.querySelector('.js-formError');
  let emailRegex  = /\S+@\S+/;
  let phoneRegex  = /^\d{3}-\d{3}-\d{4}$/;

  let validations = {
    email: {
      rule( val ) {
        return val === '' || emailRegex.test( val );
      },
      errorMsg: 'Please enter a valid email'
    },
    phone: {
      rule( val ) {
        return val === '' || phoneRegex.test( val );
      },
      errorMsg: 'Please enter a valid phone number'
    }
  };

  let fieldsToSubmit = [ name, email, phone, waitlist_id ];

  [ phone, email ].forEach( ( input ) => {
    input.addEventListener( 'keyup', ( evt ) => {
      checkRequiredFields( evt );
      setInputError( evt.target, '' );
      setFormError('');
    });
  });

  form.addEventListener( 'submit', submitForm, false );
  phoneMask( phone );

  function checkRequiredFields() {
    let phoneVal = phone.value;
    let emailVal = email.value;
    let shouldDisableBtn = ( phoneVal === '' && emailVal === '' );

    submitBtn.disabled = shouldDisableBtn;
  }

  function setFormError( txt = '' ) {
    formError.textContent = txt;
  }

  function setInputError( input, txt = '' ) {
    input.parentElement.querySelector('.error').textContent = txt;
  }

  function validateInput( input ) {
    let { name, value } = input;
    let validationObj   = validations[ name ];

    if ( typeof validationObj === 'undefined' ) {
      return true;
    }

    let { rule, errorMsg } = validationObj;

    let isValid = rule( value );
    let msg     = isValid ? '' : errorMsg;

    setInputError( input, msg );

    return isValid;
  }

  function submitForm( evt ) {
    evt.preventDefault();

    let validations = fieldsToSubmit.map( validateInput );
    let formValid   = validations.every( v => v === true );

    if ( !formValid ) {
      return;
    }

    let formData = fieldsToSubmit.reduce( ( all, next ) => {
      all[ next.name ] = next.value;
      return all;
    }, {} );

    let opts = {
      url: '/api/referred-decision-makers',
      method: 'POST'
    };

    setFormError('');

    dom.ajax( opts, formData, ( err, res ) => {
      if ( err ) {
        setFormError('An error occurred, please try again');
        return false;
      }
      return handleSuccess( res );
    });
  }

  function handleSuccess( res ) {
    // Forward user to bringmeestarry/letter page with encoded url.
    // This form is a hidden form that contains data to be passed
    // to the next page.
    let userForm = document.querySelector('.js-hiddenUserForm');

    userForm.querySelector('input[name="landlord_name"]').value = res.name;
    userForm.querySelector('input[name="landlord_email"]').value = res.email;

    userForm.submit();
  }

});

export default undefined;
